module.exports = __webpack_public_path__ + "static/media/apps.3baf8622.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/HexGrid/images/apps.png
// module id = 237
// module chunks = 0